module.exports = __webpack_public_path__ + "static/media/walletTransfer.b6ad7405.svg";